<template>

  <nav class="ms-auto" role="navigation">
    <ul class="navbar-nav" aria-label="lower navigation bar">
      <li v-if="!administrator" class="nav-item"><base-link class="nav-link" :to="'/vitalsGroup/all'" data-toggle="collapse" data-target=".navbar-collapse.show">Vitals</base-link></li>
      <li v-if="!administrator" class="nav-item"><base-link class="nav-link" :to="'/currentProviders'" data-toggle="collapse" data-target=".navbar-collapse.show">Providers</base-link></li>
      <li v-if="!administrator" class="nav-item"><base-link class="nav-link" :to="'/currentProcedures'" data-toggle="collapse" data-target=".navbar-collapse.show">Procedures</base-link></li>
      <li v-if="!administrator" class="nav-item"><base-link class="nav-link" :to="'/currentDiagnosis'" data-toggle="collapse" data-target=".navbar-collapse.show">Diagnoses</base-link ></li>
      <li v-if="!administrator" class="nav-item"><base-link class="nav-link" :to="'/currentMedications'" data-toggle="collapse" data-target=".navbar-collapse.show">Medication</base-link ></li>
      <li v-if="!administrator" class="nav-item"><base-link class="nav-link" :to="'/allergy'" data-toggle="collapse" data-target=".navbar-collapse.show">Allergies</base-link></li>
      <li v-if="administrator" class="nav-item dropdown-li"><base-link class="nav-link" :to="'/currentNurse'" data-toggle="collapse" data-target=".navbar-collapse.show">Nurses</base-link >
         <ul class="dropdown-li-ul" aria-label="dropdown">
         <!--- <li class="dropdown-li-ul-li"><router-link to="/currentNurse" @click="closeNavbar" data-toggle="collapse"
              data-target=".navbar-collapse.show">Add Nurse</router-link></li>
          <li class="dropdown-li-ul-li"><router-link to="/user/verifynurse" @click="closeNavbar" data-toggle="collapse"
              data-target=".navbar-collapse.show">Verify Nurses</router-link></li>-->
          <li class="dropdown-li-ul-li"><router-link to="/user/nursesettings" @click="closeNavbar" data-toggle="collapse"
              data-target=".navbar-collapse.show">Nurse Settings</router-link></li>
         </ul>
      </li>
      <li v-if="administrator" class="nav-item dropdown-li"><base-link class="nav-link" :to="'/patients'" data-toggle="collapse" 
        data-target=".navbar-collapse.show">Patients</base-link ></li>
      <li v-if="administrator" class="nav-item"><base-link class="nav-link" :to="'/professional-notes'" data-toggle="collapse" data-target=".navbar-collapse.show">Notes</base-link></li>
        <li v-if="administrator" class="nav-item dropdown-li "><base-link class="nav-link" :to="'/providers/alliedprofessional'" data-toggle="collapse" 
          data-target=".navbar-collapse.show">Allied Professional </base-link ></li>
          <li v-if="administrator" class="nav-item dropdown-li "><base-link class="nav-link" :to="'/nurse/homehealthaide'" data-toggle="collapse" 
            data-target=".navbar-collapse.show">Home Health Aide </base-link ></li>
            <li v-if="administrator" class="nav-item dropdown-li "><base-link class="nav-link" :to="'/scheduling'" data-toggle="collapse" 
              data-target=".navbar-collapse.show">Scheduling  </base-link ></li>
      <li v-if="administrator" class="nav-item dropdown-li"><base-link class="nav-link" :to="'/administration'" data-toggle="collapse"
        data-target=".navbar-collapse.show">Administration</base-link></li>
      <li v-if="!administrator" class="nav-item dropdown-li">
        <a class="nav-link name" >Historical<font-awesome-icon :icon="['fas', 'caret-down']" /></a>
        <ul class="dropdown-li-ul" aria-label="dropdown">
          <li class="dropdown-li-ul-li"><router-link to="/providers" @click="closeNavbar" data-toggle="collapse"
              data-target=".navbar-collapse.show">Providers</router-link></li>
          <li class="dropdown-li-ul-li"><router-link to="/procedureKinds" @click="closeNavbar" data-toggle="collapse"
              data-target=".navbar-collapse.show">Procedures</router-link></li>
          <li class="dropdown-li-ul-li"><router-link to="/labKinds" @click="closeNavbar" data-toggle="collapse"
              data-target=".navbar-collapse.show">Labs</router-link></li>
          <li class="dropdown-li-ul-li"><router-link to="/diagnosis" @click="closeNavbar" data-toggle="collapse"
              data-target=".navbar-collapse.show">Diagnoses</router-link></li>
          <li class="dropdown-li-ul-li"><router-link to="/medication" @click="closeNavbar" data-toggle="collapse"
              data-target=".navbar-collapse.show">Medications</router-link></li>
          <li class="dropdown-li-ul-li"><router-link to="/vaccination" @click="closeNavbar" data-toggle="collapse"
              data-target=".navbar-collapse.show">Vaccinations</router-link></li>
        </ul>
      </li>
      <li v-if="!administrator" class="nav-item"><base-link class="nav-link" :to="'/reports'" data-toggle="collapse" data-target=".navbar-collapse.show">Reports</base-link></li>
      <li v-if="!administrator" class="nav-item"><base-link class="nav-link" :to="'/cdas'" data-toggle="collapse" data-target=".navbar-collapse.show">CDAs</base-link></li>
      <li class="nav-item"><base-link class="nav-link" :to="'/pdfs'" data-toggle="collapse" data-target=".navbar-collapse.show">Documents</base-link ></li>
      <li v-if="!administrator" class="nav-item"><base-link class="nav-link" :to="'/data-upload'" data-toggle="collapse" data-target=".navbar-collapse.show">Upload Data</base-link ></li>
      <li v-if="!administrator" class="nav-item"><base-link class="nav-link" :to="'/watch'" data-toggle="collapse" data-target=".navbar-collapse.show">Trend Labs</base-link></li>
      <li v-if="!administrator" class="nav-item"><base-link class="nav-link" :to="'/user/devices'" data-toggle="collapse" data-target=".navbar-collapse.show">Devices</base-link></li>
      <li v-if="administrator" class="nav-item"><a class="nav-link" href="#" data-toggle="collapse" data-target=".navbar-collapse.show" @click.prevent="openBillingNav">Billing</a></li>
      <li v-if="!administrator" class="nav-item"><base-link class="nav-link" :to="'/cpt'" data-toggle="collapse" data-target=".navbar-collapse.show">CPT</base-link></li>
      <li v-if="viewingPatientChart && !administrator" class="nav-item"><base-link class="nav-link" :to="'/user/contact'" data-toggle="collapse" data-target=".navbar-collapse.show">Contacts</base-link></li>
    </ul>
  </nav>
</template>

<script>
import BaseLink from './BaseLink.vue'
import { Collapse } from "bootstrap";
import { mapGetters } from "vuex";
import {getAdministrator, isViewingPatientChart} from "@/data/getters";
import { PRIVILEGES } from "@/constants/privileges";
import { assertPrivilegeOrAlert } from "@/utils/privilegeGate";

  export default {
    name: "NavigationBarBottom",
    components: {
      'base-link': BaseLink
    },
    computed: {
      ...mapGetters('login', {
        allData: "getAllData",
      }),
      administrator: function() {
        return getAdministrator(this.allData);
      },
      viewingPatientChart() {
        return isViewingPatientChart(this.allData);
      },
    },
    methods: {
      openBillingNav() {
        this.closeNavbar();
        if (
          !assertPrivilegeOrAlert(
            PRIVILEGES.VIEW_USE_BILLING_PAGE,
            "You do not have permission to view the billing page."
          )
        ) {
          return;
        }
        this.$router.push("/cptBilling");
      },
      closeNavbar(){
      let navbar = document.querySelector('.navbar-collapse.show');
            if (navbar) {
                new Collapse(navbar, {
                    toggle: false,
                }).hide();
            }
    },
    }
  }
</script>

<style scoped lang="scss">

$color-hover: darken(#ffffff, 10%);

@import "../../../stylesheets/modules/dropdown";

.commBtn {
  background-color: transparent;
  border: none;
}

.navbar-nav {
  font-size: 0.95rem;
  font-family: "Noto Sans", system-ui, sans-serif;
  /* Same wrap as the upper row (NavigationBarTop): a nowrap flex row that
     doesn't fit widens the document and breaks full-width bands below. */
  flex-wrap: wrap;
  justify-content: flex-end;
  row-gap: 2px;

  .nav-link {
    color: #fff;
    border-bottom: 1px solid transparent;
    cursor: pointer;
    display: inline-block;
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    transition: background-color 0.15s ease;
    font-weight: 500;

    &:hover {
      background-color: rgba(75, 156, 165, 0.35);
    }
  }
}

.router-link-active {
  border-bottom: 2px solid #cb5f50 !important;
}

  .capitalize {
    text-transform: capitalize;
  }

  .base-link-active {
    border-bottom: 2px solid #cb5f50 !important;
  }

</style>
